<template>
  <div id="batchReceive">
    <a-modal
            :title="$t('batchReceive.BatchReceive')"
            v-model="visible"
            :footer="null"
            width="70%"
    >

      <a-row type="flex" justify="start">
        <a-col>
          <label style="margin-right: 4px">Carton ID: </label>
          <a-input
                  v-model="cartonIDSearchVal"
                  style="width: 150px"
                  size="small"
                  class="ml4"
                  @pressEnter="searchCartonId"
          />
        </a-col>
        <a-col class="ml4">
          <a-button size="small" type="primary" @click="searchCartonId"
          >Search</a-button
          >
        </a-col>
      </a-row>

      <a-row type="flex" justify="start">
        <a-button-group size="small">
          <a-button
                  size="small"
                  type="primary"
                  @click="AcceptSubmint"
                  :loading="AcceptLoading"
          >{{ $t("batchReceive.Accept") }}</a-button
          >
        </a-button-group>
      </a-row>
      <a-row style="margin-top: 10px" type="flex" justify="start">
        <a-col>
          <label style="margin-right: 4px"
          >{{ $t("batchReceive.ReceiveLocation") }}:
          </label>
          <a-auto-complete
                  style="width: 250px"
                  @search="handleSearch"
                  :placeholder="$t('batchReceive.EnterWordsQuery')"
                  size="small"
                  v-model="ReceiveValue"
          >
            <template slot="dataSource">
              <a-select-option
                      v-for="item in selectData"
                      :key="item.locationCode"
              >{{ item.locationName }}</a-select-option
              >
            </template>
          </a-auto-complete>
        </a-col>
        <a-col>
          <label style="margin: 0 4px" >Carton ID: </label>
          <a-input style="width: 150px" :placeholder="$t('publicLang.PleaseEnter')"  v-model="cartonId" size="small"/>
        </a-col>
      </a-row>

      <a-row style="margin-top: 5px" type="flex" justify="end">
        <a-col >
          <a-pagination
                  :pageSizeOptions="pageSizeOptions"
                  :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                  size="small"
                  :total="pagingTotal"
                  v-model="currentVal"
                  :pageSize.sync="pagingSize"
                  @change="tableChangePage"
                  @showSizeChange="onShowSizeChange"
                  showSizeChanger
          />
        </a-col >
      </a-row>

      <p class="infoError" v-if="isTabletInfo">{{ errInfo }}</p>
      <a-row style="margin-top: 10px">
        <vxe-table
                stripe
                highlight-hover-row
                highlight-hover-column
                highlightCurrentRow
                show-header-overflow
                :sort-config="{multiple: true, trigger: 'cell'}"
                border
                resizable
                max-height="500"
                height="100"
                show-overflow
                size="mini"
                ref="btchReceiveRef"
                :data.sync="tableData"
        >
          <template v-slot:empty>
            <span style="font-size: 12px; color: red">{{
              $t("pubGicSet.NoRecordfound")
            }}</span>
          </template>
          <vxe-table-column type="checkbox" width="35"></vxe-table-column>

          <vxe-table-column
                  sortable
                  field="expQty"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  :title="$t('batchReceive.EXPQty')"
          ></vxe-table-column>

          <vxe-table-column
                  sortable
                  field="rcvQty"
                  :title="$t('batchReceive.RCVQty')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
          >
            <template v-slot="{ row }">
              <a-row>
                <a-input  v-model="row.rcvQty" size="small"   style="width: 100%;"/>
              </a-row>
            </template>
          </vxe-table-column>

          <vxe-table-column
                  sortable
                  field="rcvQtyEa"
                  :title="$t('batchReceive.RCVQtyEA')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
          ></vxe-table-column>
          <vxe-table-column
                  field="cartonId"
                  :title="$t('batchReceive.CartonID')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>

          <vxe-table-column
                  field="locationCode"
                  :title="$t('batchReceive.RCVLOC') "
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>


          <vxe-table-column
                  v-if="this.systemParam.BATCH_REC_EXPIRYDATE=== 'Y'"
                  field="expriryDate"
                  :title="$t('batchReceive.EXPIRYDATE') "
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>

          <vxe-table-column
                  field="skuDesc"
                  :title="$t('batchReceive.Descr')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>
          <vxe-table-column
                  field="sku"
                  :title="$t('batchReceive.SKU')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>
          <vxe-table-column
                  field="dudf01"
                  :title="$t('batchReceive.UDF1')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>
          <vxe-table-column
                  field="dudf02"
                  :title="$t('batchReceive.UDF2')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>
          <vxe-table-column
                  field="dudf03"
                  :title="$t('batchReceive.UDF3')"
                  show-header-overflow="ellipsis"
                  show-overflow="ellipsis"
                  sortable
          ></vxe-table-column>
        </vxe-table>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import cookie from '../../../api/cookie';
  import {mapState} from "vuex";
  export default {
    computed: {
      ...mapState(["systemParam"]),
    },
    data() {
      return {
        filterName: null,
        visible: false,
        radioVal: "notReceive", // 查询条件
        tableData: [],
        partTableTargetUid: null, // 转过来当前uid
        selectData: [], // Receive Location 下拉data
        ReceiveValue: undefined, // Receive Location Value
        cartonId: undefined,
        isTabletInfo: false, // 是否出现错误提示
        errInfo: "", // 错误提示内容
        AcceptLoading: false,
        cartonIDSearchVal: null,
        serachData: [], // search table 数据
        allowInOverShip: false, // 允许RCVQty 大于 EXPQty

        pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
        pagingTotal: 0, // 总数
        pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),  // 条数
        currentVal: 1, // 页数
      };
    },
    methods: {
      onShowSizeChange(current, pageSize) {
        this.currentVal = current;
        this.pagingSize = pageSize;
        // this.initRenderFn();
        this.init();
      },
      //      表格分页
      tableChangePage(current) {
        this.currentVal = current;
        // this.initRenderFn();
        this.init();
      },

      searchCartonId() {
        this.currentVal = 1;
        this.init();
      },
      AcceptSubmint() {
        let Records = this.$refs.btchReceiveRef.getCheckboxRecords();
        // if (this.ReceiveValue == "" || this.ReceiveValue == undefined) {
        //   this.errInfo = this.$t("batchReceive.ReceiveRequired");
        //   this.isTabletInfo = true;
        //   return;
        // }

        let asnList = [];

        if (Records.length == 0) {
          this.errInfo = this.$t("publicLang.PleaseOneLeast");
          this.isTabletInfo = true;
          return;
        }else{
          for(let i in Records){
            let  asn = {};
            let expQty = Records[i].expQty;
            let rcvQty = Records[i].rcvQty;
            // 检查每一条数据RcvQty必须大于0
            if(rcvQty <= 0){
              this.errInfo = this.$t("batchReceive.RCVQtyCheck");
              //  this.errInfo = this.$t("batchReceive.RCVQtyCheck");
              this.isTabletInfo = true;
              return;
            }else if(!this.allowInOverShip){
              // 不允许RcvQty大于ExpQty(批量收货页面，如果订单数量为0，则不需要判断超收按钮是否打开，默认允许超收)
              if(expQty>0 && rcvQty > expQty){
                this.errInfo = this.$t("batchReceive.RCVQtyGtExpQty");
                this.isTabletInfo = true;
                return;
              }
            }
            asn.rcvQty = rcvQty;
            asn.uid = Records[i].uid;

            asnList.push(asn);
          }
        }




        let params = {
          asnHeaderUid: this.partTableTargetUid,
          locationCode: this.ReceiveValue,
          cartonId: this.cartonId,
          detailList: asnList,
        };
        this.isTabletInfo = false;
        this.AcceptLoading = true;
        ajax.post(api.INBOUNDBATCHRECEIVE, params).then((res) => {
          this.AcceptLoading = false;
          if (res.code == 200) {
            this.init();
            this.$message.success(res.msg);
          } else {
            this.init()
            this.$customMessage.warning(res.msg);
          }
        });
      },
      //            Receive 搜索
      handleSearch(value) {
        // 输入4个及以上个字符模糊查询
        if (value.length >= 4) {
          this.isTabletInfo = false;
          let params = {
            whsCode: this.tableData[0].whsCode,
            keyword: value,
          };
          ajax.post(api.INVENTORYLOCATION, params).then((res) => {
            this.selectData = res.data;
          });
        }else{
          this.selectData = null;
        }
      },
      //            表格数据
      init() {
        ajax.get(api.INBOUNDBATCHRECEIVE, {
          uid: this.partTableTargetUid,
          cartonId : this.cartonIDSearchVal,
          pageNum :  this.currentVal,
          pageSize : this.pagingSize
        }) .then((res) => {
          this.pagingTotal =  res.data.pagingTotal;
          this.tableData = res.data.asn;
          this.serachData = res.data.asn;
          let allowInOverShip = res.data.allowInOverShip
          if(allowInOverShip == "true"){
            this.allowInOverShip = true;
          }else{
            this.allowInOverShip = false;
          }
        });
      },
      //            显示
      show(id) {
        this.cartonIDSearchVal = null;
        this.ReceiveValue = undefined;
        this.cartonId = undefined;
        this.selectData = [];
        this.partTableTargetUid = id;
        this.visible = true;
        this.init();
      },
    },
  };
</script>